import { CircularProgress } from "@mui/material";
import React, { ReactNode } from "react";
import Icon, { IconName } from "src/components/Icon/Icon";
import { useLoading } from "src/hooks/useLoading";
import "./AppBar.scss";

export type AppBarProps = {
  icon: IconName;
  title: string;
  loading?: boolean;
  children?: ReactNode;
};

const AppBar = ({ icon, title, loading, children }: AppBarProps) => {
  const { isLoading } = useLoading();
  return (
    <div className="app-bar">
      <div className="app-bar__container">
        <div className="app-bar__icon-container">
          <Icon name={icon} size="16px" />
        </div>
        <h1 className="app-bar__title">
          {title}
          {(isLoading || loading) && <CircularProgress size="16px" sx={{ marginLeft: "1rem" }} />}
        </h1>
        <div className="app-bar__right">{children}</div>
      </div>
    </div>
  );
};

export const AppBarLarge = ({ icon, title, children, loading }: AppBarProps) => {
  const { isLoading } = useLoading();
  return (
    <div className="app-bar">
      <div className="app-bar__large-container">
        <div className="app-bar__icon-container">
          <Icon name={icon} size="16px" />
        </div>
        <h1 className="app-bar__title">
          {title}
          {(isLoading || loading) && <CircularProgress size="16px" sx={{ marginLeft: "1rem" }} />}
        </h1>
        <div className="app-bar__right">{children}</div>
      </div>
    </div>
  );
};

export default AppBar;
